import {Component, EventEmitter, inject, OnInit, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatIconModule} from '@angular/material/icon';
import {FormsModule} from '@angular/forms';
import {TpaView} from '../../../../models/tpa.enum';
import {TpaService} from "../../../../services/tpa.service";

@Component({
  selector: 'app-tpa-view-toggle',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonToggleModule,
    MatIconModule,
    FormsModule
  ],
  templateUrl: './tpa-view-toggle.component.html',
  styleUrls: ['./tpa-view-toggle.component.scss']
})
export class TpaViewToggleComponent implements OnInit {
  @Output() viewAction = new EventEmitter<TpaView>();

  currentView = TpaView.group;

  private tpaService = inject(TpaService);
  protected readonly tpaView = TpaView;

  ngOnInit(): void {
    this.initCurrentView();
  }

  onViewAction(view: TpaView) {
    this.currentView = view;
    this.viewAction.emit(view);
    this.tpaService.cacheCurrentView(view);
  }

  private initCurrentView() {
    const cachedView = this.tpaService.getCurrentView();
    if (cachedView && Object.values(TpaView).includes(cachedView)) {
      this.currentView = cachedView;
      this.onViewAction(cachedView);
    }
  }


}
